module.exports = __webpack_public_path__ + "static/media/folding.d2ceb925.svg";